// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mx-space-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.mx-space-evenly {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.mx-padded-content {
  padding: 20px;
}
.mx-ellipses {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mx-code-mirror-editor {
  border: 1px dashed #e3e3ff;
  height: calc(100% - 30px);
  max-height: 500px;
  overflow: auto;
}
.mx-code-mirror-editor .CodeMirror {
  height: 100%;
}
.mx-full-screen-height {
  height: calc(100vh - 110px);
  min-height: calc(100vh - 110px);
}
.mx-horz-gutter {
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  cursor: col-resize;
  background-color: #e4e4e4;
}
.mx-vert-gutter {
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  cursor: row-resize;
  background-color: #e4e4e4;
}
.mx-text-security {
  text-security: disc;
  -webkit-text-security: disc;
  -moz-text-security: disc;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.question-choice-select-menu .ant-select-item-option-content {
  white-space: initial;
}
.run-requests-wrapper {
  background-color: #fffbe64d;
}
.run-requests {
  border-radius: 2px;
  transition: all 0.2s;
}
.run-requests:empty {
  padding: 0;
}
.run-requests .ant-layout {
  background: transparent;
}
.run-requests > .question-group {
  max-width: 100%;
}
.run-requests > .question-group:last-child {
  margin-bottom: 0px;
}
.run-requests .technique-input-wrapper {
  position: relative;
}
.run-requests .technique-input-wrapper.extra-padding textarea {
  padding-right: 26px;
}
.run-requests .technique-input-wrapper .new-window-icon {
  position: absolute;
  top: 6px;
  right: 6px;
  cursor: pointer;
}
.run-requests .teachMeAMethodButton {
  padding-inline: 0;
  margin-block: 10px;
}
.question-answer-loader {
  padding: 20px 0;
}
.delegate .ant-input-group {
  margin-bottom: 6px;
}
.delegate .ant-form-item {
  width: 100%;
}
.question-choice .ant-select,
.question-book .ant-select {
  width: 100% !important;
}
.question-choice-view-icon {
  position: absolute;
  right: 8px;
  top: 8px;
}
.question-inputs {
  margin-top: 8px !important;
  border-radius: 4;
}
.question-inputs-retry {
  margin-top: 8px !important;
  background-color: #fafaf9 !important;
  padding: 16px;
}
.question-input-type .ant-form-item-control-input-content {
  display: flex;
  justify-content: left;
}
.question-input.sensitive {
  text-security: disc;
  -webkit-text-security: disc;
  -moz-text-security: disc;
}
.question-group.multiple .question-form {
  position: relative;
}
.question-group.multiple .question-form::after {
  content: '';
  position: absolute;
  width: calc(100% + 20px);
  height: 6px;
  background: white;
  left: -10px;
  right: 0;
  bottom: 0;
}
.question-submit {
  margin-top: 30px;
}
.question-delegate-message {
  font-style: italic;
  font-size: 11px;
  text-align: right;
}
.question-description .markdown {
  max-height: 250px;
  overflow-y: auto;
}
.answer-hint-markdown {
  word-wrap: break-word;
}
.answer-technique-line {
  white-space: pre-wrap;
}
.question.ant-layout {
  margin-top: 0 !important;
}
.question.ant-layout:empty {
  padding: 0;
}
.question.ant-layout .ant-layout {
  background: unset;
  margin-top: 10px;
}
.question.ant-layout .ant-layout-header {
  margin: 0;
  background: transparent;
  line-height: unset;
  height: unset;
  padding: 10px 0;
}
.question.ant-layout .ant-layout-header .review-trigger {
  padding-left: 5px;
}
.question.ant-layout .error-description {
  margin-top: 12px;
}
.question.ant-layout .ant-layout-sider {
  background: transparent;
  padding: 0 5px;
  margin: 3px 0;
}
.question.ant-layout .ant-layout-content {
  background: transparent;
  margin: 3px 0;
}
.question.ant-layout .ant-input-affix-wrapper {
  padding-right: 0;
  width: 100%;
}
.question.ant-layout .ant-input-affix-wrapper .ant-input-sm {
  width: 100%;
}
.question.ant-layout .ant-input-affix-wrapper .ant-input-suffix .ant-btn {
  border: 0;
}
.question.ant-layout .ant-select {
  width: 200px;
}
.question.ant-layout .ant-layout-footer {
  background: transparent;
  padding: 0px;
  margin: 0;
}
.question.ant-layout .ant-card-head {
  min-height: 30px;
}
.question.ant-layout .ant-card-head-title {
  padding: 5px 0;
}
.question.ant-layout .ant-card-body {
  padding: 10px;
}
.question.ant-layout .ant-input-group .inputValue {
  width: 100%;
}
.question.ant-layout .ant-form-item {
  margin-bottom: 0;
}
.question.ant-layout .delegate {
  display: block;
}
.review-modal .ant-modal-body {
  padding: 5px;
}
.suggestions-group {
  padding: 10px;
  border-right: 1px solid lightgray;
}
.suggestions-group .suggestion-text {
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
}
.suggestions-group .suggestion-text:hover {
  background: rgba(255, 127, 80, 0.1);
}
.suggestions-group .suggestion-border-bottom {
  border-bottom: 1px solid lightgray;
}
.grid-2 {
  grid-template-columns: 1fr 1fr !important;
}
.width-50 {
  width: 50%;
}
.answer-hint-panel {
  margin-top: 12px;
}
.answer-hint-panel .ant-collapse-header {
  padding-inline: 0 !important;
}
.question-header-wrapper .anticon {
  color: #e9b825;
  margin-right: 8px;
  font-size: 18px;
}
.question-extractions {
  margin-top: 12px;
}
.self-serve-file-upload-btn {
  border-radius: 2px;
  max-width: 180px;
}
.self-serve-hint-container {
  display: flex;
  align-items: flex-start;
  margin-top: 32px;
}
.file-icon {
  font-size: 18px;
  margin: 2px 8px;
}
.self-serve-text-container {
  display: flex;
  flex-direction: column;
}
.self-serve-text {
  margin-bottom: 12px;
}
.learning-method-used,
.available-learnings {
  margin-top: 45px;
}
.learning-method-used .-header,
.available-learnings .-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  color: #595959;
  font-size: 14px;
  font-weight: 700;
}
.learning-method-used .-header .-title > .anticon,
.available-learnings .-header .-title > .anticon {
  margin-right: 4px;
}
.learning-method-used .-header .-edit-icon,
.available-learnings .-header .-edit-icon {
  cursor: pointer;
}
.learning-method-used .ant-collapse-header,
.available-learnings .ant-collapse-header,
.learning-method-used .ant-collapse-content-box,
.available-learnings .ant-collapse-content-box {
  padding: 0 !important;
}
.learning-method-used .anticon,
.available-learnings .anticon {
  color: #595959;
}
.method-used-title {
  margin-bottom: 4px;
  color: #595959;
}
.method-used-title > .anticon {
  margin-right: 4px;
}
.method-used-title > span {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/css/mixins.less","webpack://./src/components/request/Request.less"],"names":[],"mappings":"AAgBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;ACfF;ADmBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACjBF;ADoBA;EACE,aAAA;AClBF;ADqBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;ACnBF;ADsBA;EACE,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;ACpBF;ADgBA;EAOI,YAAA;ACpBJ;ADwBA;EACE,2BAAA;EACA,+BAAA;ACtBF;ADyBA;EACE,4BAAA;EACA,wBAAA;EACA,yDAAA;EACA,kBAAA;EACA,yBAAA;ACvBF;AD0BA;EACE,4BAAA;EACA,wBAAA;EACA,yDAAA;EACA,kBAAA;EACA,yBAAA;ACxBF;AD2BA;EACE,mBAAA;EACA,2BAAA;EACA,wBAAA;ACzBF;AD+BA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AC7BF;AAlDE;EACE,oBAAA;AAoDJ;AAhDA;EACE,2BAAA;AAkDF;AA/CA;EACE,kBAAA;EACA,oBAAA;AAiDF;AA/CE;EACE,UAAA;AAiDJ;AAtDA;EASI,uBAAA;AAgDJ;AAzDA;EAaI,eAAA;AA+CJ;AA9CI;EACE,kBAAA;AAgDN;AA/DA;EAoBI,kBAAA;AA8CJ;AA3CM;EACE,mBAAA;AA6CR;AAzCI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AA2CN;AA3EA;EAqCI,iBAAA;EACA,kBAAA;AAyCJ;AArCA;EACE,eAAA;AAuCF;AAnCE;EACE,kBAAA;AAqCJ;AAlCE;EACE,WAAA;AAoCJ;AA9BE;;EACE,sBAAA;AAiCJ;AA7BA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AA+BF;AA5BA;EACE,0BAAA;EACA,gBAAA;AA8BF;AA3BA;EACE,0BAAA;EACA,oCAAA;EACA,aAAA;AA6BF;AAzBE;EACE,aAAA;EACA,qBAAA;AA2BJ;AAtBE;ED7BA,mBAAA;EACA,2BAAA;EACA,wBAAA;ACsDF;AAtBA;EAEI,kBAAA;AAuBJ;AApBI;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AAsBN;AAjBA;EACE,gBAAA;AAmBF;AAhBA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AAkBF;AAdE;EACE,iBAAA;EACA,gBAAA;AAgBJ;AAZA;EACE,qBAAA;AAcF;AAXA;EACE,qBAAA;AAaF;AAVA;EACE,wBAAA;AAYF;AARE;EACE,UAAA;AAUJ;AAhBA;EAUI,iBAAA;EACA,gBAAA;AASJ;AApBA;EAeI,SAAA;EACA,uBAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;AAMJ;AA3BA;EAwBM,iBAAA;AAMN;AAFE;EACE,gBAAA;AAIJ;AAjCA;EAiCI,uBAAA;EACA,cAAA;EACA,aAAA;AAGJ;AAtCA;EAuCI,uBAAA;EAEA,aAAA;AACJ;AA1CA;EA6CI,gBAAA;EACA,WAAA;AAAJ;AA9CA;EAiDM,WAAA;AAAN;AAjDA;EAsDQ,SAAA;AAFR;AApDA;EA4DI,YAAA;AALJ;AAvDA;EAgEI,uBAAA;EACA,YAAA;EACA,SAAA;AANJ;AA5DA;EAsEI,gBAAA;AAPJ;AA/DA;EAyEI,cAAA;AAPJ;AAlEA;EA6EI,aAAA;AARJ;AArEA;EAiFM,WAAA;AATN;AAxEA;EAqFI,gBAAA;AAVJ;AA3EA;EAyFI,cAAA;AAXJ;AAeA;EAEI,YAAA;AAdJ;AAkBA;EACE,aAAA;EACA,iCAAA;AAhBF;AAcA;EAKI,kBAAA;EACA,YAAA;EACA,eAAA;AAhBJ;AAkBI;EACE,mCAAA;AAhBN;AAMA;EAeI,kCAAA;AAlBJ;AAsBA;EACE,yCAAA;AApBF;AAuBA;EACE,UAAA;AArBF;AAwBA;EACE,gBAAA;AAtBF;AAwBE;EACE,4BAAA;AAtBJ;AA2BE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAzBJ;AA6BA;EACE,gBAAA;AA3BF;AA8BA;EACE,kBAAA;EACA,gBAAA;AA5BF;AA+BA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AA7BF;AAgCA;EACE,eAAA;EACA,eAAA;AA9BF;AAiCA;EACE,aAAA;EACA,sBAAA;AA/BF;AAkCA;EACE,mBAAA;AAhCF;AAmCA;;EAEE,gBAAA;AAjCF;AA+BA;;EAKI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAhCJ;AAmCM;;EACE,iBAAA;AAhCR;AAiBA;;EAoBM,eAAA;AAjCN;AAqCE;;;;EAEE,qBAAA;AAjCJ;AAoCE;;EACE,cAAA;AAjCJ;AAqCA;EACE,kBAAA;EACA,cAAA;AAnCF;AAqCE;EACE,iBAAA;AAnCJ;AAsCE;EACE,gBAAA;AApCJ","sourcesContent":[".mx-font-smoothing (@smoothing) when (@smoothing = antialiased) {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: @smoothing;\n  -moz-font-smoothing: @smoothing;\n  -o-font-smoothing: @smoothing;\n  font-smoothing: @smoothing;\n}\n\n.mx-font-smoothing (@smoothing: none) {\n  -webkit-font-smoothing: @smoothing;\n  -moz-font-smoothing: @smoothing;\n  -o-font-smoothing: @smoothing;\n  font-smoothing: @smoothing;\n}\n\n// dashboard style wrap\n.mx-space-wrap {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n// left/right align\n.mx-space-evenly {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.mx-padded-content {\n  padding: 20px;\n}\n\n.mx-ellipses {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mx-code-mirror-editor {\n  border: 1px dashed @border-color;\n  height: calc(~'100% - 30px');\n  max-height: 500px;\n  overflow: auto;\n\n  .CodeMirror {\n    height: 100%;\n  }\n}\n\n.mx-full-screen-height {\n  height: calc(100vh - 110px);\n  min-height: calc(100vh - 110px);\n}\n\n.mx-horz-gutter {\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');\n  cursor: col-resize;\n  background-color: @color-grey-4;\n}\n\n.mx-vert-gutter {\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');\n  cursor: row-resize;\n  background-color: @color-grey-4;\n}\n\n.mx-text-security {\n  text-security: disc;\n  -webkit-text-security: disc;\n  -moz-text-security: disc;\n}\n\n// Adding a new one - Please use prefix mx-\n// Thanks !\n\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n","@import '@css/variables.less';\n@import '@css/mixins.less';\n\n.question-choice-select-menu {\n  & .ant-select-item-option-content {\n    white-space: initial;\n  }\n}\n\n.run-requests-wrapper {\n  background-color: #fffbe64d; // opacity 30%\n}\n\n.run-requests {\n  border-radius: 2px;\n  transition: all 0.2s;\n\n  &:empty {\n    padding: 0;\n  }\n\n  .ant-layout {\n    background: transparent;\n  }\n\n  > .question-group {\n    max-width: 100%;\n    &:last-child {\n      margin-bottom: 0px;\n    }\n  }\n\n  .technique-input-wrapper {\n    position: relative;\n\n    &.extra-padding {\n      & textarea {\n        padding-right: 26px;\n      }\n    }\n\n    & .new-window-icon {\n      position: absolute;\n      top: 6px;\n      right: 6px;\n      cursor: pointer;\n    }\n  }\n\n  .teachMeAMethodButton {\n    padding-inline: 0;\n    margin-block: 10px;\n  }\n}\n\n.question-answer-loader {\n  padding: 20px 0;\n}\n\n.delegate {\n  & .ant-input-group {\n    margin-bottom: 6px;\n  }\n\n  & .ant-form-item {\n    width: 100%;\n  }\n}\n\n.question-choice,\n.question-book {\n  & .ant-select {\n    width: 100% !important;\n  }\n}\n\n.question-choice-view-icon {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n}\n\n.question-inputs {\n  margin-top: 8px !important;\n  border-radius: 4;\n}\n\n.question-inputs-retry {\n  margin-top: 8px !important;\n  background-color: #fafaf9 !important;\n  padding: 16px;\n}\n\n.question-input-type {\n  & .ant-form-item-control-input-content {\n    display: flex;\n    justify-content: left;\n  }\n}\n\n.question-input {\n  &.sensitive {\n    .mx-text-security();\n  }\n}\n\n.question-group.multiple {\n  .question-form {\n    position: relative;\n\n    // A question may have multiple sub-questions. Hence using this hack to indicate separation between questions.\n    &::after {\n      content: '';\n      position: absolute;\n      width: calc(100% + 20px);\n      height: 6px;\n      background: white;\n      left: -10px;\n      right: 0;\n      bottom: 0;\n    }\n  }\n}\n\n.question-submit {\n  margin-top: 30px;\n}\n\n.question-delegate-message {\n  font-style: italic;\n  font-size: 11px;\n  text-align: right;\n}\n\n.question-description {\n  & .markdown {\n    max-height: 250px;\n    overflow-y: auto;\n  }\n}\n\n.answer-hint-markdown {\n  word-wrap: break-word;\n}\n\n.answer-technique-line {\n  white-space: pre-wrap;\n}\n\n.question.ant-layout {\n  margin-top: 0 !important;\n  // background-color: #efefefb0;\n  // border-radius: 8px;\n\n  &:empty {\n    padding: 0;\n  }\n\n  .ant-layout {\n    background: unset;\n    margin-top: 10px;\n  }\n\n  .ant-layout-header {\n    margin: 0;\n    background: transparent;\n    // border-bottom: 1px solid orange;\n    // border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    line-height: unset;\n    height: unset;\n    padding: 10px 0;\n\n    .review-trigger {\n      padding-left: 5px;\n    }\n  }\n\n  & .error-description {\n    margin-top: 12px;\n  }\n\n  .ant-layout-sider {\n    background: transparent;\n    padding: 0 5px;\n    margin: 3px 0;\n  }\n\n  .ant-layout-content {\n    background: transparent;\n    // padding: 0 5px;\n    margin: 3px 0;\n  }\n\n  .ant-input-affix-wrapper {\n    padding-right: 0;\n    width: 100%;\n\n    .ant-input-sm {\n      width: 100%;\n    }\n\n    .ant-input-suffix {\n      .ant-btn {\n        border: 0;\n      }\n    }\n  }\n\n  .ant-select {\n    width: 200px;\n  }\n\n  .ant-layout-footer {\n    background: transparent;\n    padding: 0px;\n    margin: 0;\n  }\n\n  .ant-card-head {\n    min-height: 30px;\n  }\n  .ant-card-head-title {\n    padding: 5px 0;\n  }\n\n  .ant-card-body {\n    padding: 10px;\n  }\n  .ant-input-group {\n    .inputValue {\n      width: 100%;\n    }\n  }\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n\n  .delegate {\n    display: block;\n  }\n}\n\n.review-modal {\n  .ant-modal-body {\n    padding: 5px;\n  }\n}\n\n.suggestions-group {\n  padding: 10px;\n  border-right: 1px solid lightgray;\n\n  .suggestion-text {\n    border-radius: 4px;\n    padding: 4px;\n    cursor: pointer;\n\n    &:hover {\n      background: rgba(255, 127, 80, 0.1);\n    }\n  }\n\n  .suggestion-border-bottom {\n    border-bottom: 1px solid lightgray;\n  }\n}\n\n.grid-2 {\n  grid-template-columns: 1fr 1fr !important;\n}\n\n.width-50 {\n  width: 50%;\n}\n\n.answer-hint-panel {\n  margin-top: 12px;\n\n  & .ant-collapse-header {\n    padding-inline: 0 !important;\n  }\n}\n\n.question-header-wrapper {\n  & .anticon {\n    color: #e9b825;\n    margin-right: 8px;\n    font-size: 18px;\n  }\n}\n\n.question-extractions {\n  margin-top: 12px;\n}\n\n.self-serve-file-upload-btn {\n  border-radius: 2px;\n  max-width: 180px;\n}\n\n.self-serve-hint-container {\n  display: flex;\n  align-items: flex-start;\n  margin-top: 32px;\n}\n\n.file-icon {\n  font-size: 18px;\n  margin: 2px 8px;\n}\n\n.self-serve-text-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.self-serve-text {\n  margin-bottom: 12px;\n}\n\n.learning-method-used,\n.available-learnings {\n  margin-top: 45px;\n\n  .-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n    color: #595959;\n    font-size: 14px;\n    font-weight: 700;\n\n    .-title {\n      & > .anticon {\n        margin-right: 4px;\n      }\n    }\n\n    .-edit-icon {\n      cursor: pointer;\n    }\n  }\n\n  & .ant-collapse-header,\n  & .ant-collapse-content-box {\n    padding: 0 !important;\n  }\n\n  & .anticon {\n    color: #595959;\n  }\n}\n\n.method-used-title {\n  margin-bottom: 4px;\n  color: #595959;\n\n  & > .anticon {\n    margin-right: 4px;\n  }\n\n  & > span {\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
